import * as Sentry from '@sentry/node'
import getConfig from 'next/config'
import { Integrations } from '@sentry/tracing'
import { CaptureConsole } from '@sentry/integrations'

const isBrowser = () => typeof window !== 'undefined'

export const trackPageReload = () => {
  if (!isBrowser()) return
  const entry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming

  if (entry?.type !== 'reload') {
    return
  }

  //Note: this will also be captured when the page is hidden for too long
  Sentry.captureMessage('Page reload', {
    level: Sentry.Severity.Info,
    extra: {
      reload_source: 'web',
      url: window.location.href,
      userAgent: navigator.userAgent
    }
  })
}

let initialize = false
export function initSentry() {
  if (initialize) return
  initialize = true
  const config = getConfig().publicRuntimeConfig
  const sentryDsn = isBrowser() ? config.sentryDsn : process.env.Sentry__Dsn
  const sentryEnvironment = isBrowser() ? config.env : process.env.env
  const buildVersion = isBrowser() ? config.buildVersion : process.env.BUILD_VERSION

  if (sentryDsn) {
    const integrations = [
      new Integrations.BrowserTracing(),
      new CaptureConsole({
        levels: ['error', 'warn']
      })
    ]
    Sentry.init({
      ignoreErrors: [
        /^\[Meta Pixel\] - Invalid PixelID: null.$/,
        /^\[Facebook Pixel\] - Invalid PixelID.*$/,
        /^\[Meta Pixel\] - Pixel.*not found$/,
        /^\[Facebook Pixel\] - Pixel .* not found$/,
        /^Client input error.*$/,
        /^LogRocket has already been loaded, loading a second instance is not supported.$/,
        /^LogRocket filter manager is using too much memory. Disabling.$/,
        // /Failed to load Stripe.js/,
        /^TypeError.*$/,
        /^LogRocket.*$/,
        /This version has Break Change/,
        /Cannot assign to read only property/,
        /^Cannot freeze*$/,
        /^Attempted to assign to readonly property.*$/,
        /^Error: AbortError*$/,
        /^[Meta Pixel] - Duplicate Pixel ID*$/
      ],
      beforeSend(event) {
        // Check if the event contains a message and matches the regex pattern
        // const regex = /^[Meta Pixel] - Duplicate Pixel ID*$/ // Replace with your actual regex
        if (event.message?.includes('Duplicate Pixel ID')) {
          // Discard the event by returning null if it matches the regex
          return null
        }
        // Otherwise, send the event to Sentry
        return event
      },
      integrations,
      dsn: sentryDsn,
      environment: sentryEnvironment,
      release: buildVersion
    })
  }
}
